export default {
  header: {
    title: 'Montant de la donation',
    subtitle: 'Configurez votre donation ci-dessous :',
    sideTitle: 'Montant total',
    hint: 'Les dons de somme d\'argent exonérés permettent de transmettre de son vivant jusqu\'à 31 865 € sans fiscalité tous les 15 ans, sous réserve de respecter des conditions d\'âge pour le donateur et le donataire.'
  }
}
